/* tslint:disable */
/* eslint-disable */
/**
 * SALESTA API Service
 * App API
 *
 * The version of the OpenAPI document: v1
 * Contact: admin@salesta.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountVO
 */
export interface AccountVO {
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'account'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'accountNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'bankTransferBranchName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'bankTransferName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'depositTypeCategoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountVO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'payeeKatakanaName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'payeeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'postCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'printedPayeeName2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'printedPaymentDestinationName1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'salesOfficeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'telephoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'tempPass'?: string;
}
/**
 * 
 * @export
 * @interface EmailTemplateParam
 */
export interface EmailTemplateParam {
    /**
     * content
     * @type {string}
     * @memberof EmailTemplateParam
     */
    'content': string;
    /**
     * name
     * @type {string}
     * @memberof EmailTemplateParam
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EmailTemplateVO
 */
export interface EmailTemplateVO {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateVO
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof EmailTemplateVO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateVO
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface FileMetaData
 */
export interface FileMetaData {
    /**
     * 
     * @type {number}
     * @memberof FileMetaData
     */
    'contentSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaData
     */
    'contentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetaData
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaData
     */
    'details'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetaData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaData
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaData
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface FileMetaDataVO
 */
export interface FileMetaDataVO {
    /**
     * 
     * @type {number}
     * @memberof FileMetaDataVO
     */
    'contentSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaDataVO
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaDataVO
     */
    'downloadLocation'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetaDataVO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaDataVO
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaDataVO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaDataVO
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface FileUpload
 */
export interface FileUpload {
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    'file'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    'filePath'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileUpload
     */
    'fileSize'?: number;
}
/**
 * 
 * @export
 * @interface ImportLog
 */
export interface ImportLog {
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'clientId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLog
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'errorCodes'?: string;
    /**
     * 
     * @type {FileMetaData}
     * @memberof ImportLog
     */
    'fileMetaData'?: FileMetaData;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLog
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'importPublishedStatus'?: ImportLogImportPublishedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'importStatus'?: ImportLogImportStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'importType'?: ImportLogImportTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ImportLog
     */
    'invalidCase'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'ip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'processingEndedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'processingStartedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'publishedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLog
     */
    'setRootId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'storageType'?: ImportLogStorageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'usr'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLog
     */
    'validCase'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLog
     */
    'validFlag'?: ImportLogValidFlagEnum;
}

export const ImportLogImportPublishedStatusEnum = {
    Published: 'PUBLISHED',
    Unpublished: 'UNPUBLISHED',
    InProgress: 'IN_PROGRESS',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogImportPublishedStatusEnum = typeof ImportLogImportPublishedStatusEnum[keyof typeof ImportLogImportPublishedStatusEnum];
export const ImportLogImportStatusEnum = {
    Normal: 'NORMAL',
    PartialError: 'PARTIAL_ERROR',
    Error: 'ERROR',
    Processing: 'PROCESSING',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogImportStatusEnum = typeof ImportLogImportStatusEnum[keyof typeof ImportLogImportStatusEnum];
export const ImportLogImportTypeEnum = {
    Api: 'API',
    Manual: 'MANUAL',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogImportTypeEnum = typeof ImportLogImportTypeEnum[keyof typeof ImportLogImportTypeEnum];
export const ImportLogStorageTypeEnum = {
    MasterPayee: 'MASTER_PAYEE',
    PayeeInvoice: 'PAYEE_INVOICE',
    PayeeCredential: 'PAYEE_CREDENTIAL',
    InactivePayeeCredential: 'INACTIVE_PAYEE_CREDENTIAL',
    IndividualGuidance: 'INDIVIDUAL_GUIDANCE',
    AllGuidance: 'ALL_GUIDANCE',
    UserManual: 'USER_MANUAL',
    UserQrCode: 'USER_QR_CODE',
    Temp: 'TEMP'
} as const;

export type ImportLogStorageTypeEnum = typeof ImportLogStorageTypeEnum[keyof typeof ImportLogStorageTypeEnum];
export const ImportLogValidFlagEnum = {
    Invalid: 'INVALID',
    Valid: 'VALID',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogValidFlagEnum = typeof ImportLogValidFlagEnum[keyof typeof ImportLogValidFlagEnum];

/**
 * 
 * @export
 * @interface ImportLogPublishedParam
 */
export interface ImportLogPublishedParam {
    /**
     * publishedDate
     * @type {string}
     * @memberof ImportLogPublishedParam
     */
    'publicationDate': string;
}
/**
 * 
 * @export
 * @interface ImportLogVO
 */
export interface ImportLogVO {
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'clientId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLogVO
     */
    'createdAt'?: number;
    /**
     * 
     * @type {FileMetaDataVO}
     * @memberof ImportLogVO
     */
    'fileMetaData'?: FileMetaDataVO;
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLogVO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'importStatus'?: ImportLogVOImportStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'importType'?: ImportLogVOImportTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ImportLogVO
     */
    'invalidCase'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'ip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportLogVO
     */
    'usr'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportLogVO
     */
    'validCase'?: number;
}

export const ImportLogVOImportStatusEnum = {
    Normal: 'NORMAL',
    PartialError: 'PARTIAL_ERROR',
    Error: 'ERROR',
    Processing: 'PROCESSING',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogVOImportStatusEnum = typeof ImportLogVOImportStatusEnum[keyof typeof ImportLogVOImportStatusEnum];
export const ImportLogVOImportTypeEnum = {
    Api: 'API',
    Manual: 'MANUAL',
    Unknown: 'UNKNOWN'
} as const;

export type ImportLogVOImportTypeEnum = typeof ImportLogVOImportTypeEnum[keyof typeof ImportLogVOImportTypeEnum];

/**
 * 
 * @export
 * @interface InvoiceVO
 */
export interface InvoiceVO {
    /**
     * 
     * @type {number}
     * @memberof InvoiceVO
     */
    'actualPaymentAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'closingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'closingDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'closingMonth'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'closingYear'?: string;
    /**
     * 
     * @type {FileMetaDataVO}
     * @memberof InvoiceVO
     */
    'fileMetaData'?: FileMetaDataVO;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceVO
     */
    'filePublished'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvoiceVO
     */
    'id'?: number;
    /**
     * 
     * @type {ImportLogVO}
     * @memberof InvoiceVO
     */
    'importLog'?: ImportLogVO;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'importPublishedStatus'?: InvoiceVOImportPublishedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'locationFeePaymentPlanedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'partOf'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'payeeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceVO
     */
    'payeeName'?: string;
}

export const InvoiceVOImportPublishedStatusEnum = {
    Published: 'PUBLISHED',
    Unpublished: 'UNPUBLISHED',
    InProgress: 'IN_PROGRESS',
    Unknown: 'UNKNOWN'
} as const;

export type InvoiceVOImportPublishedStatusEnum = typeof InvoiceVOImportPublishedStatusEnum[keyof typeof InvoiceVOImportPublishedStatusEnum];

/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'createdAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'jobResult'?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'jobStatus'?: JobJobStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'jobType'?: JobJobTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'uniqueJobName'?: string;
}

export const JobJobStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Draft: 'DRAFT',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    Unknown: 'UNKNOWN'
} as const;

export type JobJobStatusEnum = typeof JobJobStatusEnum[keyof typeof JobJobStatusEnum];
export const JobJobTypeEnum = {
    Upload: 'UPLOAD',
    Download: 'DOWNLOAD'
} as const;

export type JobJobTypeEnum = typeof JobJobTypeEnum[keyof typeof JobJobTypeEnum];

/**
 * 
 * @export
 * @interface JobResult
 */
export interface JobResult {
    /**
     * 
     * @type {FileUpload}
     * @memberof JobResult
     */
    'fileDetails'?: FileUpload;
    /**
     * 
     * @type {Job}
     * @memberof JobResult
     */
    'job'?: Job;
}
/**
 * 
 * @export
 * @interface MessageVO
 */
export interface MessageVO {
    /**
     * 
     * @type {number}
     * @memberof MessageVO
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageVO
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'absoluteFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'absolutePath'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'canonicalFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'canonicalPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'directory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'executable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'file'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'freeSpace'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'lastModified'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'parent'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'parentFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'readable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'totalSpace'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'usableSpace'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'writable'?: boolean;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Pageable
     */
    'paged'?: boolean;
    /**
     * 
     * @type {Sort}
     * @memberof Pageable
     */
    'sort'?: Sort;
    /**
     * 
     * @type {boolean}
     * @memberof Pageable
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof Resource
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'filename'?: string;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'readable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'uri'?: string;
    /**
     * 
     * @type {URL}
     * @memberof Resource
     */
    'url'?: URL;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {Array<ImportLog>}
     * @memberof Response
     */
    'content'?: Array<ImportLog>;
    /**
     * 
     * @type {boolean}
     * @memberof Response
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Response
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Response
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof Response
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'size'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof Response
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface ResponseEntity
 */
export interface ResponseEntity {
    /**
     * 
     * @type {object}
     * @memberof ResponseEntity
     */
    'body'?: object;
    /**
     * 
     * @type {string}
     * @memberof ResponseEntity
     */
    'statusCode'?: ResponseEntityStatusCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof ResponseEntity
     */
    'statusCodeValue'?: number;
}

export const ResponseEntityStatusCodeEnum = {
    _100Continue: '100 CONTINUE',
    _101SwitchingProtocols: '101 SWITCHING_PROTOCOLS',
    _102Processing: '102 PROCESSING',
    _103Checkpoint: '103 CHECKPOINT',
    _200Ok: '200 OK',
    _201Created: '201 CREATED',
    _202Accepted: '202 ACCEPTED',
    _203NonAuthoritativeInformation: '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent: '204 NO_CONTENT',
    _205ResetContent: '205 RESET_CONTENT',
    _206PartialContent: '206 PARTIAL_CONTENT',
    _207MultiStatus: '207 MULTI_STATUS',
    _208AlreadyReported: '208 ALREADY_REPORTED',
    _226ImUsed: '226 IM_USED',
    _300MultipleChoices: '300 MULTIPLE_CHOICES',
    _301MovedPermanently: '301 MOVED_PERMANENTLY',
    _302Found: '302 FOUND',
    _302MovedTemporarily: '302 MOVED_TEMPORARILY',
    _303SeeOther: '303 SEE_OTHER',
    _304NotModified: '304 NOT_MODIFIED',
    _305UseProxy: '305 USE_PROXY',
    _307TemporaryRedirect: '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect: '308 PERMANENT_REDIRECT',
    _400BadRequest: '400 BAD_REQUEST',
    _401Unauthorized: '401 UNAUTHORIZED',
    _402PaymentRequired: '402 PAYMENT_REQUIRED',
    _403Forbidden: '403 FORBIDDEN',
    _404NotFound: '404 NOT_FOUND',
    _405MethodNotAllowed: '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable: '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired: '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout: '408 REQUEST_TIMEOUT',
    _409Conflict: '409 CONFLICT',
    _410Gone: '410 GONE',
    _411LengthRequired: '411 LENGTH_REQUIRED',
    _412PreconditionFailed: '412 PRECONDITION_FAILED',
    _413PayloadTooLarge: '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge: '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong: '414 URI_TOO_LONG',
    _414RequestUriTooLong: '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType: '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable: '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed: '417 EXPECTATION_FAILED',
    _418IAmATeapot: '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource: '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure: '420 METHOD_FAILURE',
    _421DestinationLocked: '421 DESTINATION_LOCKED',
    _422UnprocessableEntity: '422 UNPROCESSABLE_ENTITY',
    _423Locked: '423 LOCKED',
    _424FailedDependency: '424 FAILED_DEPENDENCY',
    _426UpgradeRequired: '426 UPGRADE_REQUIRED',
    _428PreconditionRequired: '428 PRECONDITION_REQUIRED',
    _429TooManyRequests: '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge: '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons: '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError: '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented: '501 NOT_IMPLEMENTED',
    _502BadGateway: '502 BAD_GATEWAY',
    _503ServiceUnavailable: '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout: '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported: '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates: '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage: '507 INSUFFICIENT_STORAGE',
    _508LoopDetected: '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded: '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended: '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired: '511 NETWORK_AUTHENTICATION_REQUIRED'
} as const;

export type ResponseEntityStatusCodeEnum = typeof ResponseEntityStatusCodeEnum[keyof typeof ResponseEntityStatusCodeEnum];

/**
 * 
 * @export
 * @interface SettingParam
 */
export interface SettingParam {
    /**
     * configurationKey
     * @type {string}
     * @memberof SettingParam
     */
    'configurationKey': SettingParamConfigurationKeyEnum;
    /**
     * configurationValue
     * @type {string}
     * @memberof SettingParam
     */
    'configurationValue': string;
    /**
     * domain
     * @type {string}
     * @memberof SettingParam
     */
    'domain': SettingParamDomainEnum;
    /**
     * valueDataType
     * @type {string}
     * @memberof SettingParam
     */
    'valueDataType': SettingParamValueDataTypeEnum;
}

export const SettingParamConfigurationKeyEnum = {
    CompanyName: 'company_name',
    CompanyDetails: 'company_details',
    InvoiceLimitInMonth: 'invoice_limit_in_month',
    UserPanelManualLastUpdated: 'user_panel_manual_last_updated',
    AdminPanelManualLastUpdated: 'admin_panel_manual_last_updated',
    ImportPublication: 'import_publication',
    ShouldMaskBankInfo: 'should_mask_bank_info',
    IpAccessRestriction: 'ip_access_restriction'
} as const;

export type SettingParamConfigurationKeyEnum = typeof SettingParamConfigurationKeyEnum[keyof typeof SettingParamConfigurationKeyEnum];
export const SettingParamDomainEnum = {
    Company: 'COMPANY',
    Invoice: 'INVOICE',
    Manual: 'MANUAL'
} as const;

export type SettingParamDomainEnum = typeof SettingParamDomainEnum[keyof typeof SettingParamDomainEnum];
export const SettingParamValueDataTypeEnum = {
    String: 'string',
    Int: 'int',
    Double: 'double',
    Long: 'long',
    Boolean: 'boolean'
} as const;

export type SettingParamValueDataTypeEnum = typeof SettingParamValueDataTypeEnum[keyof typeof SettingParamValueDataTypeEnum];

/**
 * 
 * @export
 * @interface SettingVO
 */
export interface SettingVO {
    /**
     * 
     * @type {string}
     * @memberof SettingVO
     */
    'configurationKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingVO
     */
    'configurationValue'?: string;
    /**
     * 
     * @type {number}
     * @memberof SettingVO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SettingVO
     */
    'lastModifiedAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof SettingVO
     */
    'valueDataType'?: string;
}
/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface URI
 */
export interface URI {
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'fragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'host'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'opaque'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URI
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawAuthority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawFragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawQuery'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawSchemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawUserInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'scheme'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'schemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface URL
 */
export interface URL {
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'authority'?: string;
    /**
     * 
     * @type {object}
     * @memberof URL
     */
    'content'?: object;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'defaultPort'?: number;
    /**
     * 
     * @type {object}
     * @memberof URL
     */
    'deserializedFields'?: object;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'file'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'host'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'protocol'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'ref'?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'serializedHashCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmailParam
 */
export interface UpdateEmailParam {
    /**
     * user\'s email
     * @type {string}
     * @memberof UpdateEmailParam
     */
    'newEmail': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmailParam
     */
    'otp'?: number;
}
/**
 * 
 * @export
 * @interface UpdatePasswordParam
 */
export interface UpdatePasswordParam {
    /**
     * newPassword
     * @type {string}
     * @memberof UpdatePasswordParam
     */
    'newPassword': string;
    /**
     * oldPassword
     * @type {string}
     * @memberof UpdatePasswordParam
     */
    'oldPassword': string;
}
/**
 * 
 * @export
 * @interface UserLog
 */
export interface UserLog {
    /**
     * 
     * @type {string}
     * @memberof UserLog
     */
    'clientId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserLog
     */
    'createdAt'?: number;
    /**
     * eventKey
     * @type {string}
     * @memberof UserLog
     */
    'eventKey': UserLogEventKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof UserLog
     */
    'eventName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserLog
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserLog
     */
    'userId'?: string;
}

export const UserLogEventKeyEnum = {
    EmailUpdateDate: 'EMAIL_UPDATE_DATE',
    PasswordUpdateDate: 'PASSWORD_UPDATE_DATE',
    UserActivatedDate: 'USER_ACTIVATED_DATE',
    UserInvalidatedDate: 'USER_INVALIDATED_DATE',
    InvoiceUpdatedDate: 'INVOICE_UPDATED_DATE'
} as const;

export type UserLogEventKeyEnum = typeof UserLogEventKeyEnum[keyof typeof UserLogEventKeyEnum];

/**
 * 
 * @export
 * @interface UserStatusParam
 */
export interface UserStatusParam {
    /**
     * 
     * @type {string}
     * @memberof UserStatusParam
     */
    'accountStatus'?: UserStatusParamAccountStatusEnum;
}

export const UserStatusParamAccountStatusEnum = {
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Invalid: 'INVALID',
    Unknown: 'UNKNOWN'
} as const;

export type UserStatusParamAccountStatusEnum = typeof UserStatusParamAccountStatusEnum[keyof typeof UserStatusParamAccountStatusEnum];

/**
 * 
 * @export
 * @interface UserUploadVO
 */
export interface UserUploadVO {
    /**
     * 
     * @type {number}
     * @memberof UserUploadVO
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UserVO
 */
export interface UserVO {
    /**
     * 
     * @type {AccountVO}
     * @memberof UserVO
     */
    'account'?: AccountVO;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'accountStatus'?: UserVOAccountStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'lastLoginAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'userId'?: string;
}

export const UserVOAccountStatusEnum = {
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Invalid: 'INVALID',
    Unknown: 'UNKNOWN'
} as const;

export type UserVOAccountStatusEnum = typeof UserVOAccountStatusEnum[keyof typeof UserVOAccountStatusEnum];

/**
 * 
 * @export
 * @interface UuserResponse
 */
export interface UuserResponse {
    /**
     * 
     * @type {Array<UserVO>}
     * @memberof UuserResponse
     */
    'content'?: Array<UserVO>;
    /**
     * 
     * @type {boolean}
     * @memberof UuserResponse
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UuserResponse
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UuserResponse
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UuserResponse
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof UuserResponse
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof UuserResponse
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof UuserResponse
     */
    'size'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof UuserResponse
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof UuserResponse
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof UuserResponse
     */
    'totalPages'?: number;
}

/**
 * AppUserControllerApi - axios parameter creator
 * @export
 */
export const AppUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} accountStatus [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtAfterOrLastModifiedAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {number} [lastModifiedAtAfter] unix milli timestamp
         * @param {number} [lastModifiedAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET: async (authorization: string, accountSource: string, accountStatus: string, createdAtAfter?: number, createdAtAfterOrLastModifiedAtAfter?: number, createdAtBefore?: number, lastModifiedAtAfter?: number, lastModifiedAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET', 'authorization', authorization)
            // verify required parameter 'accountSource' is not null or undefined
            assertParamExists('allUsingGET', 'accountSource', accountSource)
            // verify required parameter 'accountStatus' is not null or undefined
            assertParamExists('allUsingGET', 'accountStatus', accountStatus)
            const localVarPath = `/api/v1/app/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountSource !== undefined) {
                localVarQueryParameter['accountSource'] = accountSource;
            }

            if (accountStatus !== undefined) {
                localVarQueryParameter['accountStatus'] = accountStatus;
            }

            if (createdAtAfter !== undefined) {
                localVarQueryParameter['createdAtAfter'] = createdAtAfter;
            }

            if (createdAtAfterOrLastModifiedAtAfter !== undefined) {
                localVarQueryParameter['createdAtAfterOrLastModifiedAtAfter'] = createdAtAfterOrLastModifiedAtAfter;
            }

            if (createdAtBefore !== undefined) {
                localVarQueryParameter['createdAtBefore'] = createdAtBefore;
            }

            if (lastModifiedAtAfter !== undefined) {
                localVarQueryParameter['lastModifiedAtAfter'] = lastModifiedAtAfter;
            }

            if (lastModifiedAtBefore !== undefined) {
                localVarQueryParameter['lastModifiedAtBefore'] = lastModifiedAtBefore;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (salesOfficeName !== undefined) {
                localVarQueryParameter['salesOfficeName'] = salesOfficeName;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete User and Associated Data
         * @param {string} authorization 
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAndAssociatedDataUsingDELETE: async (authorization: string, userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUserAndAssociatedDataUsingDELETE', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserAndAssociatedDataUsingDELETE', 'userId', userId)
            const localVarPath = `/api/v1/app/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByUserIdUsingGET: async (authorization: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailByUserIdUsingGET', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('detailByUserIdUsingGET', 'userId', userId)
            const localVarPath = `/api/v1/app/users/{userId}/byUserId`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detailUsingGET', 'id', id)
            const localVarPath = `/api/v1/app/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserCredentialUsingGET: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllInactiveUserCredentialUsingGET', 'authorization', authorization)
            const localVarPath = `/api/v1/app/users/user-guidance/userGuidance.zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all unique sales office names.
         * @summary Get All Sales Offices
         * @param {string} authorization Bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSalesOfficesUsingGET: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllSalesOfficesUsingGET', 'authorization', authorization)
            const localVarPath = `/api/v1/app/users/salesofficeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} authorization token
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInactiveUserCredentialByIdsUsingGET: async (authorization: string, userIds: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInactiveUserCredentialByIdsUsingGET', 'authorization', authorization)
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('getInactiveUserCredentialByIdsUsingGET', 'userIds', userIds)
            const localVarPath = `/api/v1/app/users/user-guidance/{userIds}/userGuidance.zip`
                .replace(`{${"userIds"}}`, encodeURIComponent(String(userIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} authorization token
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialCredentialByUserIdUsingGET: async (authorization: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInitialCredentialByUserIdUsingGET', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getInitialCredentialByUserIdUsingGET', 'userId', userId)
            const localVarPath = `/api/v1/app/users/user-guidance/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary hasDuplicateEmail
         * @param {string} authorization token
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasDuplicateEmailUsingGET: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('hasDuplicateEmailUsingGET', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hasDuplicateEmailUsingGET', 'id', id)
            const localVarPath = `/api/v1/app/users/has-duplicate-email/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppUserControllerApi - functional programming interface
 * @export
 */
export const AppUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} accountStatus [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtAfterOrLastModifiedAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {number} [lastModifiedAtAfter] unix milli timestamp
         * @param {number} [lastModifiedAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET(authorization: string, accountSource: string, accountStatus: string, createdAtAfter?: number, createdAtAfterOrLastModifiedAtAfter?: number, createdAtBefore?: number, lastModifiedAtAfter?: number, lastModifiedAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UuserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET(authorization, accountSource, accountStatus, createdAtAfter, createdAtAfterOrLastModifiedAtAfter, createdAtBefore, lastModifiedAtAfter, lastModifiedAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete User and Associated Data
         * @param {string} authorization 
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserAndAssociatedDataUsingDELETE(authorization: string, userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAndAssociatedDataUsingDELETE(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailByUserIdUsingGET(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInactiveUserCredentialUsingGET(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInactiveUserCredentialUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of all unique sales office names.
         * @summary Get All Sales Offices
         * @param {string} authorization Bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSalesOfficesUsingGET(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSalesOfficesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} authorization token
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInactiveUserCredentialByIdsUsingGET(authorization: string, userIds: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInactiveUserCredentialByIdsUsingGET(authorization, userIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} authorization token
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialCredentialByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialCredentialByUserIdUsingGET(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary hasDuplicateEmail
         * @param {string} authorization token
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasDuplicateEmailUsingGET(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasDuplicateEmailUsingGET(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppUserControllerApi - factory interface
 * @export
 */
export const AppUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} accountStatus [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtAfterOrLastModifiedAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {number} [lastModifiedAtAfter] unix milli timestamp
         * @param {number} [lastModifiedAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET(authorization: string, accountSource: string, accountStatus: string, createdAtAfter?: number, createdAtAfterOrLastModifiedAtAfter?: number, createdAtBefore?: number, lastModifiedAtAfter?: number, lastModifiedAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: any): AxiosPromise<UuserResponse> {
            return localVarFp.allUsingGET(authorization, accountSource, accountStatus, createdAtAfter, createdAtAfterOrLastModifiedAtAfter, createdAtBefore, lastModifiedAtAfter, lastModifiedAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete User and Associated Data
         * @param {string} authorization 
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAndAssociatedDataUsingDELETE(authorization: string, userId: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.deleteUserAndAssociatedDataUsingDELETE(authorization, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByUserIdUsingGET(authorization: string, userId: string, options?: any): AxiosPromise<UserVO> {
            return localVarFp.detailByUserIdUsingGET(authorization, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET(authorization: string, id: number, options?: any): AxiosPromise<UserVO> {
            return localVarFp.detailUsingGET(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserCredentialUsingGET(authorization: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAllInactiveUserCredentialUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all unique sales office names.
         * @summary Get All Sales Offices
         * @param {string} authorization Bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSalesOfficesUsingGET(authorization: string, options?: any): AxiosPromise<object> {
            return localVarFp.getAllSalesOfficesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} authorization token
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInactiveUserCredentialByIdsUsingGET(authorization: string, userIds: string, options?: any): AxiosPromise<string> {
            return localVarFp.getInactiveUserCredentialByIdsUsingGET(authorization, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} authorization token
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialCredentialByUserIdUsingGET(authorization: string, userId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getInitialCredentialByUserIdUsingGET(authorization, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary hasDuplicateEmail
         * @param {string} authorization token
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasDuplicateEmailUsingGET(authorization: string, id: number, options?: any): AxiosPromise<object> {
            return localVarFp.hasDuplicateEmailUsingGET(authorization, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppUserControllerApi - object-oriented interface
 * @export
 * @class AppUserControllerApi
 * @extends {BaseAPI}
 */
export class AppUserControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {string} accountSource [ADMIN, SYSTEM]
     * @param {string} accountStatus [ACTIVE, INACTIVE, INVALID]
     * @param {number} [createdAtAfter] unix milli timestamp
     * @param {number} [createdAtAfterOrLastModifiedAtAfter] unix milli timestamp
     * @param {number} [createdAtBefore] unix milli timestamp
     * @param {number} [lastModifiedAtAfter] unix milli timestamp
     * @param {number} [lastModifiedAtBefore] unix milli timestamp
     * @param {string} [name] user\&#39;s name
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [salesOfficeName] salesOfficeName
     * @param {string} [sortBy] 
     * @param {string} [userId] user\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public allUsingGET(authorization: string, accountSource: string, accountStatus: string, createdAtAfter?: number, createdAtAfterOrLastModifiedAtAfter?: number, createdAtBefore?: number, lastModifiedAtAfter?: number, lastModifiedAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).allUsingGET(authorization, accountSource, accountStatus, createdAtAfter, createdAtAfterOrLastModifiedAtAfter, createdAtBefore, lastModifiedAtAfter, lastModifiedAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete User and Associated Data
     * @param {string} authorization 
     * @param {number} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public deleteUserAndAssociatedDataUsingDELETE(authorization: string, userId: number, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).deleteUserAndAssociatedDataUsingDELETE(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public detailByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).detailByUserIdUsingGET(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public detailUsingGET(authorization: string, id: number, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).detailUsingGET(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllInactiveUserCredential
     * @param {string} authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public getAllInactiveUserCredentialUsingGET(authorization: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).getAllInactiveUserCredentialUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all unique sales office names.
     * @summary Get All Sales Offices
     * @param {string} authorization Bearer token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public getAllSalesOfficesUsingGET(authorization: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).getAllSalesOfficesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getInactiveUserCredentialByIds
     * @param {string} authorization token
     * @param {string} userIds userIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public getInactiveUserCredentialByIdsUsingGET(authorization: string, userIds: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).getInactiveUserCredentialByIdsUsingGET(authorization, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getInitialCredentialByUserId
     * @param {string} authorization token
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public getInitialCredentialByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).getInitialCredentialByUserIdUsingGET(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary hasDuplicateEmail
     * @param {string} authorization token
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public hasDuplicateEmailUsingGET(authorization: string, id: number, options?: AxiosRequestConfig) {
        return AppUserControllerApiFp(this.configuration).hasDuplicateEmailUsingGET(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerImportControllerApi - axios parameter creator
 * @export
 */
export const CustomerImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} [accountStatus] [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET1: async (authorization: string, accountSource: string, accountStatus?: string, createdAtAfter?: number, createdAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET1', 'authorization', authorization)
            // verify required parameter 'accountSource' is not null or undefined
            assertParamExists('allUsingGET1', 'accountSource', accountSource)
            const localVarPath = `/api/v1/app/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountSource !== undefined) {
                localVarQueryParameter['accountSource'] = accountSource;
            }

            if (accountStatus !== undefined) {
                localVarQueryParameter['accountStatus'] = accountStatus;
            }

            if (createdAtAfter !== undefined) {
                localVarQueryParameter['createdAtAfter'] = createdAtAfter;
            }

            if (createdAtBefore !== undefined) {
                localVarQueryParameter['createdAtBefore'] = createdAtBefore;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (salesOfficeName !== undefined) {
                localVarQueryParameter['salesOfficeName'] = salesOfficeName;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET1: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET1', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detailUsingGET1', 'id', id)
            const localVarPath = `/api/v1/app/customers/imports/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {number} [isUpdateInfo] isUpdateInfo
         * @param {number} [updateBlank] updateBlank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMasterPayeeUsingPOST: async (authorization: string, files: any, isUpdateInfo?: number, updateBlank?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeMasterPayeeUsingPOST', 'authorization', authorization)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('storeMasterPayeeUsingPOST', 'files', files)
            const localVarPath = `/api/v1/app/customers/imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (isUpdateInfo !== undefined) {
                localVarQueryParameter['isUpdateInfo'] = isUpdateInfo;
            }

            if (updateBlank !== undefined) {
                localVarQueryParameter['updateBlank'] = updateBlank;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerImportControllerApi - functional programming interface
 * @export
 */
export const CustomerImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} [accountStatus] [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET1(authorization: string, accountSource: string, accountStatus?: string, createdAtAfter?: number, createdAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET1(authorization, accountSource, accountStatus, createdAtAfter, createdAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET1(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET1(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {number} [isUpdateInfo] isUpdateInfo
         * @param {number} [updateBlank] updateBlank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeMasterPayeeUsingPOST(authorization: string, files: any, isUpdateInfo?: number, updateBlank?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUploadVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeMasterPayeeUsingPOST(authorization, files, isUpdateInfo, updateBlank, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerImportControllerApi - factory interface
 * @export
 */
export const CustomerImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} accountSource [ADMIN, SYSTEM]
         * @param {string} [accountStatus] [ACTIVE, INACTIVE, INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [name] user\&#39;s name
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [salesOfficeName] salesOfficeName
         * @param {string} [sortBy] 
         * @param {string} [userId] user\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET1(authorization: string, accountSource: string, accountStatus?: string, createdAtAfter?: number, createdAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.allUsingGET1(authorization, accountSource, accountStatus, createdAtAfter, createdAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET1(authorization: string, id: number, options?: any): AxiosPromise<ImportLog> {
            return localVarFp.detailUsingGET1(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {number} [isUpdateInfo] isUpdateInfo
         * @param {number} [updateBlank] updateBlank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMasterPayeeUsingPOST(authorization: string, files: any, isUpdateInfo?: number, updateBlank?: number, options?: any): AxiosPromise<UserUploadVO> {
            return localVarFp.storeMasterPayeeUsingPOST(authorization, files, isUpdateInfo, updateBlank, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerImportControllerApi - object-oriented interface
 * @export
 * @class CustomerImportControllerApi
 * @extends {BaseAPI}
 */
export class CustomerImportControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {string} accountSource [ADMIN, SYSTEM]
     * @param {string} [accountStatus] [ACTIVE, INACTIVE, INVALID]
     * @param {number} [createdAtAfter] unix milli timestamp
     * @param {number} [createdAtBefore] unix milli timestamp
     * @param {string} [name] user\&#39;s name
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [salesOfficeName] salesOfficeName
     * @param {string} [sortBy] 
     * @param {string} [userId] user\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerImportControllerApi
     */
    public allUsingGET1(authorization: string, accountSource: string, accountStatus?: string, createdAtAfter?: number, createdAtBefore?: number, name?: string, pageNo?: number, pageSize?: number, salesOfficeName?: string, sortBy?: string, userId?: string, options?: AxiosRequestConfig) {
        return CustomerImportControllerApiFp(this.configuration).allUsingGET1(authorization, accountSource, accountStatus, createdAtAfter, createdAtBefore, name, pageNo, pageSize, salesOfficeName, sortBy, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerImportControllerApi
     */
    public detailUsingGET1(authorization: string, id: number, options?: AxiosRequestConfig) {
        return CustomerImportControllerApiFp(this.configuration).detailUsingGET1(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {any} files files
     * @param {number} [isUpdateInfo] isUpdateInfo
     * @param {number} [updateBlank] updateBlank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerImportControllerApi
     */
    public storeMasterPayeeUsingPOST(authorization: string, files: any, isUpdateInfo?: number, updateBlank?: number, options?: AxiosRequestConfig) {
        return CustomerImportControllerApiFp(this.configuration).storeMasterPayeeUsingPOST(authorization, files, isUpdateInfo, updateBlank, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmailTemplateControllerApi - axios parameter creator
 * @export
 */
export const EmailTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET2: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET2', 'authorization', authorization)
            const localVarPath = `/api/v1/app/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST: async (authorization: string, param: EmailTemplateParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createUsingPOST', 'authorization', authorization)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('createUsingPOST', 'param', param)
            const localVarPath = `/api/v1/app/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUsingDELETE', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUsingDELETE', 'id', id)
            const localVarPath = `/api/v1/app/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByNameUsingGET: async (authorization: string, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailByNameUsingGET', 'authorization', authorization)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('detailByNameUsingGET', 'name', name)
            const localVarPath = `/api/v1/app/email-templates/{name}/details-by-name`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET2: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET2', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detailUsingGET2', 'id', id)
            const localVarPath = `/api/v1/app/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT1: async (authorization: string, id: number, param: EmailTemplateParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUsingPUT1', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsingPUT1', 'id', id)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('updateUsingPUT1', 'param', param)
            const localVarPath = `/api/v1/app/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailTemplateControllerApi - functional programming interface
 * @export
 */
export const EmailTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET2(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailTemplateVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET2(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsingPOST(authorization: string, param: EmailTemplateParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsingPOST(authorization, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsingDELETE(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsingDELETE(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailByNameUsingGET(authorization: string, name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailByNameUsingGET(authorization, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET2(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET2(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsingPUT1(authorization: string, id: number, param: EmailTemplateParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsingPUT1(authorization, id, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailTemplateControllerApi - factory interface
 * @export
 */
export const EmailTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET2(authorization: string, options?: any): AxiosPromise<Array<EmailTemplateVO>> {
            return localVarFp.allUsingGET2(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST(authorization: string, param: EmailTemplateParam, options?: any): AxiosPromise<EmailTemplateVO> {
            return localVarFp.createUsingPOST(authorization, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE(authorization: string, id: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.deleteUsingDELETE(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByNameUsingGET(authorization: string, name: string, options?: any): AxiosPromise<EmailTemplateVO> {
            return localVarFp.detailByNameUsingGET(authorization, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET2(authorization: string, id: number, options?: any): AxiosPromise<EmailTemplateVO> {
            return localVarFp.detailUsingGET2(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {EmailTemplateParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT1(authorization: string, id: number, param: EmailTemplateParam, options?: any): AxiosPromise<EmailTemplateVO> {
            return localVarFp.updateUsingPUT1(authorization, id, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailTemplateControllerApi - object-oriented interface
 * @export
 * @class EmailTemplateControllerApi
 * @extends {BaseAPI}
 */
export class EmailTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public allUsingGET2(authorization: string, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).allUsingGET2(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {EmailTemplateParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public createUsingPOST(authorization: string, param: EmailTemplateParam, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).createUsingPOST(authorization, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public deleteUsingDELETE(authorization: string, id: number, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).deleteUsingDELETE(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public detailByNameUsingGET(authorization: string, name: string, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).detailByNameUsingGET(authorization, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public detailUsingGET2(authorization: string, id: number, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).detailUsingGET2(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update
     * @param {string} authorization 
     * @param {number} id 
     * @param {EmailTemplateParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateControllerApi
     */
    public updateUsingPUT1(authorization: string, id: number, param: EmailTemplateParam, options?: AxiosRequestConfig) {
        return EmailTemplateControllerApiFp(this.configuration).updateUsingPUT1(authorization, id, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HeartbeatControllerApi - axios parameter creator
 * @export
 */
export const HeartbeatControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Heartbeat
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {string} [limitKey] limit key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatUsingGET: async (authorization: string, xTenantID: string, limitKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('heartbeatUsingGET', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('heartbeatUsingGET', 'xTenantID', xTenantID)
            const localVarPath = `/api/v1/app/heartbeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (limitKey !== undefined && limitKey !== null) {
                localVarHeaderParameter['Limit-Key'] = String(limitKey);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatControllerApi - functional programming interface
 * @export
 */
export const HeartbeatControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HeartbeatControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Heartbeat
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {string} [limitKey] limit key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async heartbeatUsingGET(authorization: string, xTenantID: string, limitKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.heartbeatUsingGET(authorization, xTenantID, limitKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HeartbeatControllerApi - factory interface
 * @export
 */
export const HeartbeatControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HeartbeatControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Heartbeat
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {string} [limitKey] limit key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatUsingGET(authorization: string, xTenantID: string, limitKey?: string, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.heartbeatUsingGET(authorization, xTenantID, limitKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HeartbeatControllerApi - object-oriented interface
 * @export
 * @class HeartbeatControllerApi
 * @extends {BaseAPI}
 */
export class HeartbeatControllerApi extends BaseAPI {
    /**
     * 
     * @summary Heartbeat
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {string} [limitKey] limit key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatControllerApi
     */
    public heartbeatUsingGET(authorization: string, xTenantID: string, limitKey?: string, options?: AxiosRequestConfig) {
        return HeartbeatControllerApiFp(this.configuration).heartbeatUsingGET(authorization, xTenantID, limitKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImportLogControllerApi - axios parameter creator
 * @export
 */
export const ImportLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} importStatus [NORMAL,PARTIAL_ERROR,ERROR]
         * @param {string} validFlag [VALID,INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [importType] [API,MANUAL]
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [storageType] [MASTER_PAYEE,PAYEE_INVOICE]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET3: async (authorization: string, importPublishedStatus: string, importStatus: string, validFlag: string, createdAtAfter?: number, createdAtBefore?: number, importType?: string, pageNo?: number, pageSize?: number, sortBy?: string, storageType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET3', 'authorization', authorization)
            // verify required parameter 'importPublishedStatus' is not null or undefined
            assertParamExists('allUsingGET3', 'importPublishedStatus', importPublishedStatus)
            // verify required parameter 'importStatus' is not null or undefined
            assertParamExists('allUsingGET3', 'importStatus', importStatus)
            // verify required parameter 'validFlag' is not null or undefined
            assertParamExists('allUsingGET3', 'validFlag', validFlag)
            const localVarPath = `/api/v1/app/import-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (createdAtAfter !== undefined) {
                localVarQueryParameter['createdAtAfter'] = createdAtAfter;
            }

            if (createdAtBefore !== undefined) {
                localVarQueryParameter['createdAtBefore'] = createdAtBefore;
            }

            if (importPublishedStatus !== undefined) {
                localVarQueryParameter['importPublishedStatus'] = importPublishedStatus;
            }

            if (importStatus !== undefined) {
                localVarQueryParameter['importStatus'] = importStatus;
            }

            if (importType !== undefined) {
                localVarQueryParameter['importType'] = importType;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (storageType !== undefined) {
                localVarQueryParameter['storageType'] = storageType;
            }

            if (validFlag !== undefined) {
                localVarQueryParameter['validFlag'] = validFlag;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE1: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUsingDELETE1', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUsingDELETE1', 'id', id)
            const localVarPath = `/api/v1/app/import-logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary publishInvoiceById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishInvoiceByIdUsingPUT: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('publishInvoiceByIdUsingPUT', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publishInvoiceByIdUsingPUT', 'id', id)
            const localVarPath = `/api/v1/app/import-logs/{id}/immediate-publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary publishInvoiceSetById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishInvoiceSetByIdUsingPUT: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('publishInvoiceSetByIdUsingPUT', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publishInvoiceSetByIdUsingPUT', 'id', id)
            const localVarPath = `/api/v1/app/import-logs/{id}/immediate-publish-for-set`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary setPublishedDateForSet
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPublishedDateForSetUsingPUT: async (authorization: string, id: number, param: ImportLogPublishedParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('setPublishedDateForSetUsingPUT', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setPublishedDateForSetUsingPUT', 'id', id)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('setPublishedDateForSetUsingPUT', 'param', param)
            const localVarPath = `/api/v1/app/import-logs/{id}/set-published-date-for-set`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary setPublishedDate
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPublishedDateUsingPUT: async (authorization: string, id: number, param: ImportLogPublishedParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('setPublishedDateUsingPUT', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setPublishedDateUsingPUT', 'id', id)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('setPublishedDateUsingPUT', 'param', param)
            const localVarPath = `/api/v1/app/import-logs/{id}/set-published-date`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportLogControllerApi - functional programming interface
 * @export
 */
export const ImportLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} importStatus [NORMAL,PARTIAL_ERROR,ERROR]
         * @param {string} validFlag [VALID,INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [importType] [API,MANUAL]
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [storageType] [MASTER_PAYEE,PAYEE_INVOICE]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET3(authorization: string, importPublishedStatus: string, importStatus: string, validFlag: string, createdAtAfter?: number, createdAtBefore?: number, importType?: string, pageNo?: number, pageSize?: number, sortBy?: string, storageType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET3(authorization, importPublishedStatus, importStatus, validFlag, createdAtAfter, createdAtBefore, importType, pageNo, pageSize, sortBy, storageType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsingDELETE1(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsingDELETE1(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary publishInvoiceById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishInvoiceByIdUsingPUT(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishInvoiceByIdUsingPUT(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary publishInvoiceSetById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishInvoiceSetByIdUsingPUT(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishInvoiceSetByIdUsingPUT(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary setPublishedDateForSet
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPublishedDateForSetUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPublishedDateForSetUsingPUT(authorization, id, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary setPublishedDate
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPublishedDateUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPublishedDateUsingPUT(authorization, id, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImportLogControllerApi - factory interface
 * @export
 */
export const ImportLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} importStatus [NORMAL,PARTIAL_ERROR,ERROR]
         * @param {string} validFlag [VALID,INVALID]
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [importType] [API,MANUAL]
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [storageType] [MASTER_PAYEE,PAYEE_INVOICE]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET3(authorization: string, importPublishedStatus: string, importStatus: string, validFlag: string, createdAtAfter?: number, createdAtBefore?: number, importType?: string, pageNo?: number, pageSize?: number, sortBy?: string, storageType?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.allUsingGET3(authorization, importPublishedStatus, importStatus, validFlag, createdAtAfter, createdAtBefore, importType, pageNo, pageSize, sortBy, storageType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE1(authorization: string, id: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.deleteUsingDELETE1(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary publishInvoiceById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishInvoiceByIdUsingPUT(authorization: string, id: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.publishInvoiceByIdUsingPUT(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary publishInvoiceSetById
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishInvoiceSetByIdUsingPUT(authorization: string, id: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.publishInvoiceSetByIdUsingPUT(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary setPublishedDateForSet
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPublishedDateForSetUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.setPublishedDateForSetUsingPUT(authorization, id, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary setPublishedDate
         * @param {string} authorization 
         * @param {number} id 
         * @param {ImportLogPublishedParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPublishedDateUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.setPublishedDateUsingPUT(authorization, id, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportLogControllerApi - object-oriented interface
 * @export
 * @class ImportLogControllerApi
 * @extends {BaseAPI}
 */
export class ImportLogControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
     * @param {string} importStatus [NORMAL,PARTIAL_ERROR,ERROR]
     * @param {string} validFlag [VALID,INVALID]
     * @param {number} [createdAtAfter] unix milli timestamp
     * @param {number} [createdAtBefore] unix milli timestamp
     * @param {string} [importType] [API,MANUAL]
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [sortBy] 
     * @param {string} [storageType] [MASTER_PAYEE,PAYEE_INVOICE]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public allUsingGET3(authorization: string, importPublishedStatus: string, importStatus: string, validFlag: string, createdAtAfter?: number, createdAtBefore?: number, importType?: string, pageNo?: number, pageSize?: number, sortBy?: string, storageType?: string, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).allUsingGET3(authorization, importPublishedStatus, importStatus, validFlag, createdAtAfter, createdAtBefore, importType, pageNo, pageSize, sortBy, storageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public deleteUsingDELETE1(authorization: string, id: number, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).deleteUsingDELETE1(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary publishInvoiceById
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public publishInvoiceByIdUsingPUT(authorization: string, id: number, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).publishInvoiceByIdUsingPUT(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary publishInvoiceSetById
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public publishInvoiceSetByIdUsingPUT(authorization: string, id: number, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).publishInvoiceSetByIdUsingPUT(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary setPublishedDateForSet
     * @param {string} authorization 
     * @param {number} id 
     * @param {ImportLogPublishedParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public setPublishedDateForSetUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).setPublishedDateForSetUsingPUT(authorization, id, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary setPublishedDate
     * @param {string} authorization 
     * @param {number} id 
     * @param {ImportLogPublishedParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportLogControllerApi
     */
    public setPublishedDateUsingPUT(authorization: string, id: number, param: ImportLogPublishedParam, options?: AxiosRequestConfig) {
        return ImportLogControllerApiFp(this.configuration).setPublishedDateUsingPUT(authorization, id, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvoiceControllerApi - axios parameter creator
 * @export
 */
export const InvoiceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} userId user\&#39;s ID
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [day] Day
         * @param {string} [month] Month
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [year] Year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET4: async (authorization: string, importPublishedStatus: string, userId: string, createdAtAfter?: number, createdAtBefore?: number, day?: string, month?: string, pageNo?: number, pageSize?: number, sortBy?: string, year?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET4', 'authorization', authorization)
            // verify required parameter 'importPublishedStatus' is not null or undefined
            assertParamExists('allUsingGET4', 'importPublishedStatus', importPublishedStatus)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('allUsingGET4', 'userId', userId)
            const localVarPath = `/api/v1/app/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (createdAtAfter !== undefined) {
                localVarQueryParameter['createdAtAfter'] = createdAtAfter;
            }

            if (createdAtBefore !== undefined) {
                localVarQueryParameter['createdAtBefore'] = createdAtBefore;
            }

            if (day !== undefined) {
                localVarQueryParameter['day'] = day;
            }

            if (importPublishedStatus !== undefined) {
                localVarQueryParameter['importPublishedStatus'] = importPublishedStatus;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Latest Published
         * @param {string} authorization token
         * @param {string} userId user\&#39;s ID
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLatestPublishedUsingGET: async (authorization: string, userId: string, sortBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('findAllLatestPublishedUsingGET', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('findAllLatestPublishedUsingGET', 'userId', userId)
            const localVarPath = `/api/v1/app/invoices/latest-published`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization token
         * @param {string} location ./file_storage/dummy_store/some_file.pdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET: async (authorization: string, location: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET', 'authorization', authorization)
            // verify required parameter 'location' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET', 'location', location)
            const localVarPath = `/api/v1/app/invoices/findByLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceControllerApi - functional programming interface
 * @export
 */
export const InvoiceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} userId user\&#39;s ID
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [day] Day
         * @param {string} [month] Month
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [year] Year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET4(authorization: string, importPublishedStatus: string, userId: string, createdAtAfter?: number, createdAtBefore?: number, day?: string, month?: string, pageNo?: number, pageSize?: number, sortBy?: string, year?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET4(authorization, importPublishedStatus, userId, createdAtAfter, createdAtBefore, day, month, pageNo, pageSize, sortBy, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List Latest Published
         * @param {string} authorization token
         * @param {string} userId user\&#39;s ID
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLatestPublishedUsingGET(authorization: string, userId: string, sortBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLatestPublishedUsingGET(authorization, userId, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization token
         * @param {string} location ./file_storage/dummy_store/some_file.pdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileWithMediaTypeUsingGET(authorization: string, location: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileWithMediaTypeUsingGET(authorization, location, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoiceControllerApi - factory interface
 * @export
 */
export const InvoiceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
         * @param {string} userId user\&#39;s ID
         * @param {number} [createdAtAfter] unix milli timestamp
         * @param {number} [createdAtBefore] unix milli timestamp
         * @param {string} [day] Day
         * @param {string} [month] Month
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [year] Year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET4(authorization: string, importPublishedStatus: string, userId: string, createdAtAfter?: number, createdAtBefore?: number, day?: string, month?: string, pageNo?: number, pageSize?: number, sortBy?: string, year?: string, options?: any): AxiosPromise<Array<InvoiceVO>> {
            return localVarFp.allUsingGET4(authorization, importPublishedStatus, userId, createdAtAfter, createdAtBefore, day, month, pageNo, pageSize, sortBy, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Latest Published
         * @param {string} authorization token
         * @param {string} userId user\&#39;s ID
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLatestPublishedUsingGET(authorization: string, userId: string, sortBy?: string, options?: any): AxiosPromise<Array<InvoiceVO>> {
            return localVarFp.findAllLatestPublishedUsingGET(authorization, userId, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization token
         * @param {string} location ./file_storage/dummy_store/some_file.pdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET(authorization: string, location: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFileWithMediaTypeUsingGET(authorization, location, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceControllerApi - object-oriented interface
 * @export
 * @class InvoiceControllerApi
 * @extends {BaseAPI}
 */
export class InvoiceControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {string} importPublishedStatus [PUBLISHED,UNPUBLISHED]
     * @param {string} userId user\&#39;s ID
     * @param {number} [createdAtAfter] unix milli timestamp
     * @param {number} [createdAtBefore] unix milli timestamp
     * @param {string} [day] Day
     * @param {string} [month] Month
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [sortBy] 
     * @param {string} [year] Year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApi
     */
    public allUsingGET4(authorization: string, importPublishedStatus: string, userId: string, createdAtAfter?: number, createdAtBefore?: number, day?: string, month?: string, pageNo?: number, pageSize?: number, sortBy?: string, year?: string, options?: AxiosRequestConfig) {
        return InvoiceControllerApiFp(this.configuration).allUsingGET4(authorization, importPublishedStatus, userId, createdAtAfter, createdAtBefore, day, month, pageNo, pageSize, sortBy, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Latest Published
     * @param {string} authorization token
     * @param {string} userId user\&#39;s ID
     * @param {string} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApi
     */
    public findAllLatestPublishedUsingGET(authorization: string, userId: string, sortBy?: string, options?: AxiosRequestConfig) {
        return InvoiceControllerApiFp(this.configuration).findAllLatestPublishedUsingGET(authorization, userId, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFileWithMediaType
     * @param {string} authorization token
     * @param {string} location ./file_storage/dummy_store/some_file.pdf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApi
     */
    public getFileWithMediaTypeUsingGET(authorization: string, location: string, options?: AxiosRequestConfig) {
        return InvoiceControllerApiFp(this.configuration).getFileWithMediaTypeUsingGET(authorization, location, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PayeeUploadControllerApi - axios parameter creator
 * @export
 */
export const PayeeUploadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMasterPayeeUsingPOST1: async (authorization: string, files: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeMasterPayeeUsingPOST1', 'authorization', authorization)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('storeMasterPayeeUsingPOST1', 'files', files)
            const localVarPath = `/api/v1/app/payee-data-upload/master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePayeeReportUsingPOST: async (authorization: string, files: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storePayeeReportUsingPOST', 'authorization', authorization)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('storePayeeReportUsingPOST', 'files', files)
            const localVarPath = `/api/v1/app/payee-data-upload/billing-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayeeUploadControllerApi - functional programming interface
 * @export
 */
export const PayeeUploadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayeeUploadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeMasterPayeeUsingPOST1(authorization: string, files: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeMasterPayeeUsingPOST1(authorization, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storePayeeReportUsingPOST(authorization: string, files: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storePayeeReportUsingPOST(authorization, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PayeeUploadControllerApi - factory interface
 * @export
 */
export const PayeeUploadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayeeUploadControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMasterPayeeUsingPOST1(authorization: string, files: any, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.storeMasterPayeeUsingPOST1(authorization, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePayeeReportUsingPOST(authorization: string, files: any, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.storePayeeReportUsingPOST(authorization, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayeeUploadControllerApi - object-oriented interface
 * @export
 * @class PayeeUploadControllerApi
 * @extends {BaseAPI}
 */
export class PayeeUploadControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {any} files files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayeeUploadControllerApi
     */
    public storeMasterPayeeUsingPOST1(authorization: string, files: any, options?: AxiosRequestConfig) {
        return PayeeUploadControllerApiFp(this.configuration).storeMasterPayeeUsingPOST1(authorization, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {any} files files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayeeUploadControllerApi
     */
    public storePayeeReportUsingPOST(authorization: string, files: any, options?: AxiosRequestConfig) {
        return PayeeUploadControllerApiFp(this.configuration).storePayeeReportUsingPOST(authorization, files, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportImportControllerApi - axios parameter creator
 * @export
 */
export const ReportImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET3: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET3', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detailUsingGET3', 'id', id)
            const localVarPath = `/api/v1/app/reports/imports/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization 
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET1: async (authorization: string, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET1', 'authorization', authorization)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET1', 'fileName', fileName)
            const localVarPath = `/api/v1/app/reports/exports/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeInvoiceDataUsingPOST: async (authorization: string, files: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeInvoiceDataUsingPOST', 'authorization', authorization)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('storeInvoiceDataUsingPOST', 'files', files)
            const localVarPath = `/api/v1/app/reports/imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportImportControllerApi - functional programming interface
 * @export
 */
export const ReportImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET3(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET3(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization 
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileWithMediaTypeUsingGET1(authorization: string, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileWithMediaTypeUsingGET1(authorization, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeInvoiceDataUsingPOST(authorization: string, files: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeInvoiceDataUsingPOST(authorization, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportImportControllerApi - factory interface
 * @export
 */
export const ReportImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET3(authorization: string, id: number, options?: any): AxiosPromise<ImportLog> {
            return localVarFp.detailUsingGET3(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} authorization 
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET1(authorization: string, fileName: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFileWithMediaTypeUsingGET1(authorization, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeInvoiceDataUsingPOST(authorization: string, files: any, options?: any): AxiosPromise<ImportLog> {
            return localVarFp.storeInvoiceDataUsingPOST(authorization, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportImportControllerApi - object-oriented interface
 * @export
 * @class ReportImportControllerApi
 * @extends {BaseAPI}
 */
export class ReportImportControllerApi extends BaseAPI {
    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportImportControllerApi
     */
    public detailUsingGET3(authorization: string, id: number, options?: AxiosRequestConfig) {
        return ReportImportControllerApiFp(this.configuration).detailUsingGET3(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFileWithMediaType
     * @param {string} authorization 
     * @param {string} fileName fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportImportControllerApi
     */
    public getFileWithMediaTypeUsingGET1(authorization: string, fileName: string, options?: AxiosRequestConfig) {
        return ReportImportControllerApiFp(this.configuration).getFileWithMediaTypeUsingGET1(authorization, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {any} files files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportImportControllerApi
     */
    public storeInvoiceDataUsingPOST(authorization: string, files: any, options?: AxiosRequestConfig) {
        return ReportImportControllerApiFp(this.configuration).storeInvoiceDataUsingPOST(authorization, files, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SettingControllerApi - axios parameter creator
 * @export
 */
export const SettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET5: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET5', 'authorization', authorization)
            const localVarPath = `/api/v1/app/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST1: async (authorization: string, param: SettingParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createUsingPOST1', 'authorization', authorization)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('createUsingPOST1', 'param', param)
            const localVarPath = `/api/v1/app/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE2: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUsingDELETE2', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUsingDELETE2', 'id', id)
            const localVarPath = `/api/v1/app/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DetailByKey
         * @param {string} authorization 
         * @param {'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction'} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByKeyUsingGET: async (authorization: string, key: 'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailByKeyUsingGET', 'authorization', authorization)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('detailByKeyUsingGET', 'key', key)
            const localVarPath = `/api/v1/app/settings/{key}/byKey`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET4: async (authorization: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET4', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detailUsingGET4', 'id', id)
            const localVarPath = `/api/v1/app/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT2: async (authorization: string, id: number, param: SettingParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUsingPUT2', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsingPUT2', 'id', id)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('updateUsingPUT2', 'param', param)
            const localVarPath = `/api/v1/app/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingControllerApi - functional programming interface
 * @export
 */
export const SettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET5(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SettingVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET5(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsingPOST1(authorization: string, param: SettingParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsingPOST1(authorization, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsingDELETE2(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsingDELETE2(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary DetailByKey
         * @param {string} authorization 
         * @param {'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction'} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailByKeyUsingGET(authorization: string, key: 'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailByKeyUsingGET(authorization, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET4(authorization: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET4(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsingPUT2(authorization: string, id: number, param: SettingParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsingPUT2(authorization, id, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingControllerApi - factory interface
 * @export
 */
export const SettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET5(authorization: string, options?: any): AxiosPromise<Array<SettingVO>> {
            return localVarFp.allUsingGET5(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST1(authorization: string, param: SettingParam, options?: any): AxiosPromise<SettingVO> {
            return localVarFp.createUsingPOST1(authorization, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE2(authorization: string, id: number, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.deleteUsingDELETE2(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DetailByKey
         * @param {string} authorization 
         * @param {'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction'} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailByKeyUsingGET(authorization: string, key: 'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction', options?: any): AxiosPromise<SettingVO> {
            return localVarFp.detailByKeyUsingGET(authorization, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET4(authorization: string, id: number, options?: any): AxiosPromise<SettingVO> {
            return localVarFp.detailUsingGET4(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {SettingParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT2(authorization: string, id: number, param: SettingParam, options?: any): AxiosPromise<SettingVO> {
            return localVarFp.updateUsingPUT2(authorization, id, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingControllerApi - object-oriented interface
 * @export
 * @class SettingControllerApi
 * @extends {BaseAPI}
 */
export class SettingControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public allUsingGET5(authorization: string, options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).allUsingGET5(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {SettingParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public createUsingPOST1(authorization: string, param: SettingParam, options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).createUsingPOST1(authorization, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public deleteUsingDELETE2(authorization: string, id: number, options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).deleteUsingDELETE2(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DetailByKey
     * @param {string} authorization 
     * @param {'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction'} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public detailByKeyUsingGET(authorization: string, key: 'company_name' | 'company_details' | 'invoice_limit_in_month' | 'user_panel_manual_last_updated' | 'admin_panel_manual_last_updated' | 'import_publication' | 'should_mask_bank_info' | 'ip_access_restriction', options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).detailByKeyUsingGET(authorization, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public detailUsingGET4(authorization: string, id: number, options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).detailUsingGET4(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update
     * @param {string} authorization 
     * @param {number} id 
     * @param {SettingParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public updateUsingPUT2(authorization: string, id: number, param: SettingParam, options?: AxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).updateUsingPUT2(authorization, id, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UpdateEmailAppControllerApi - axios parameter creator
 * @export
 */
export const UpdateEmailAppControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary changeEmailRequest
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailRequestUsingPOST: async (authorization: string, param: UpdateEmailParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changeEmailRequestUsingPOST', 'authorization', authorization)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('changeEmailRequestUsingPOST', 'param', param)
            const localVarPath = `/api/v1/app/change-email/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary changeEmailVerify
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailVerifyUsingPUT: async (authorization: string, param: UpdateEmailParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changeEmailVerifyUsingPUT', 'authorization', authorization)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('changeEmailVerifyUsingPUT', 'param', param)
            const localVarPath = `/api/v1/app/change-email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateEmailAppControllerApi - functional programming interface
 * @export
 */
export const UpdateEmailAppControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateEmailAppControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary changeEmailRequest
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailRequestUsingPOST(authorization: string, param: UpdateEmailParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailRequestUsingPOST(authorization, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary changeEmailVerify
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailVerifyUsingPUT(authorization: string, param: UpdateEmailParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailVerifyUsingPUT(authorization, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdateEmailAppControllerApi - factory interface
 * @export
 */
export const UpdateEmailAppControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateEmailAppControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary changeEmailRequest
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailRequestUsingPOST(authorization: string, param: UpdateEmailParam, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.changeEmailRequestUsingPOST(authorization, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary changeEmailVerify
         * @param {string} authorization 
         * @param {UpdateEmailParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailVerifyUsingPUT(authorization: string, param: UpdateEmailParam, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.changeEmailVerifyUsingPUT(authorization, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateEmailAppControllerApi - object-oriented interface
 * @export
 * @class UpdateEmailAppControllerApi
 * @extends {BaseAPI}
 */
export class UpdateEmailAppControllerApi extends BaseAPI {
    /**
     * 
     * @summary changeEmailRequest
     * @param {string} authorization 
     * @param {UpdateEmailParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateEmailAppControllerApi
     */
    public changeEmailRequestUsingPOST(authorization: string, param: UpdateEmailParam, options?: AxiosRequestConfig) {
        return UpdateEmailAppControllerApiFp(this.configuration).changeEmailRequestUsingPOST(authorization, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary changeEmailVerify
     * @param {string} authorization 
     * @param {UpdateEmailParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateEmailAppControllerApi
     */
    public changeEmailVerifyUsingPUT(authorization: string, param: UpdateEmailParam, options?: AxiosRequestConfig) {
        return UpdateEmailAppControllerApiFp(this.configuration).changeEmailVerifyUsingPUT(authorization, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UpdatePasswordAppControllerApi - axios parameter creator
 * @export
 */
export const UpdatePasswordAppControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary changePassword
         * @param {string} authorization 
         * @param {UpdatePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordUsingPUT: async (authorization: string, param: UpdatePasswordParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changePasswordUsingPUT', 'authorization', authorization)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('changePasswordUsingPUT', 'param', param)
            const localVarPath = `/api/v1/app/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdatePasswordAppControllerApi - functional programming interface
 * @export
 */
export const UpdatePasswordAppControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdatePasswordAppControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary changePassword
         * @param {string} authorization 
         * @param {UpdatePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePasswordUsingPUT(authorization: string, param: UpdatePasswordParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePasswordUsingPUT(authorization, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdatePasswordAppControllerApi - factory interface
 * @export
 */
export const UpdatePasswordAppControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdatePasswordAppControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary changePassword
         * @param {string} authorization 
         * @param {UpdatePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordUsingPUT(authorization: string, param: UpdatePasswordParam, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.changePasswordUsingPUT(authorization, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdatePasswordAppControllerApi - object-oriented interface
 * @export
 * @class UpdatePasswordAppControllerApi
 * @extends {BaseAPI}
 */
export class UpdatePasswordAppControllerApi extends BaseAPI {
    /**
     * 
     * @summary changePassword
     * @param {string} authorization 
     * @param {UpdatePasswordParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdatePasswordAppControllerApi
     */
    public changePasswordUsingPUT(authorization: string, param: UpdatePasswordParam, options?: AxiosRequestConfig) {
        return UpdatePasswordAppControllerApiFp(this.configuration).changePasswordUsingPUT(authorization, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGuidanceControllerApi - axios parameter creator
 * @export
 */
export const UserGuidanceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserGuidanceUsingGET: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllInactiveUserGuidanceUsingGET', 'authorization', authorization)
            const localVarPath = `/api/v1/app/users-guidance/downloadAllInactiveUserGuidance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DownloadProcessBySalesOffice
         * @param {string} authorization token
         * @param {string} salesOffice Sales Office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAllInactiveUserGuidanceBySalesOfficeUsingGET: async (authorization: string, salesOffice: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('processAllInactiveUserGuidanceBySalesOfficeUsingGET', 'authorization', authorization)
            // verify required parameter 'salesOffice' is not null or undefined
            assertParamExists('processAllInactiveUserGuidanceBySalesOfficeUsingGET', 'salesOffice', salesOffice)
            const localVarPath = `/api/v1/app/users-guidance/processAllInactiveUserGuidanceBySalesOffice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (salesOffice !== undefined) {
                localVarQueryParameter['salesOffice'] = salesOffice;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DownloadProcess
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAllInactiveUserGuidanceUsingGET: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('processAllInactiveUserGuidanceUsingGET', 'authorization', authorization)
            const localVarPath = `/api/v1/app/users-guidance/processAllInactiveUserGuidance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGuidanceControllerApi - functional programming interface
 * @export
 */
export const UserGuidanceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGuidanceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInactiveUserGuidanceUsingGET(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInactiveUserGuidanceUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary DownloadProcessBySalesOffice
         * @param {string} authorization token
         * @param {string} salesOffice Sales Office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization: string, salesOffice: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization, salesOffice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary DownloadProcess
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processAllInactiveUserGuidanceUsingGET(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processAllInactiveUserGuidanceUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGuidanceControllerApi - factory interface
 * @export
 */
export const UserGuidanceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGuidanceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserGuidanceUsingGET(authorization: string, options?: any): AxiosPromise<JobResult> {
            return localVarFp.getAllInactiveUserGuidanceUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DownloadProcessBySalesOffice
         * @param {string} authorization token
         * @param {string} salesOffice Sales Office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization: string, salesOffice: string, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization, salesOffice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DownloadProcess
         * @param {string} authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAllInactiveUserGuidanceUsingGET(authorization: string, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.processAllInactiveUserGuidanceUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGuidanceControllerApi - object-oriented interface
 * @export
 * @class UserGuidanceControllerApi
 * @extends {BaseAPI}
 */
export class UserGuidanceControllerApi extends BaseAPI {
    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGuidanceControllerApi
     */
    public getAllInactiveUserGuidanceUsingGET(authorization: string, options?: AxiosRequestConfig) {
        return UserGuidanceControllerApiFp(this.configuration).getAllInactiveUserGuidanceUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DownloadProcessBySalesOffice
     * @param {string} authorization token
     * @param {string} salesOffice Sales Office
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGuidanceControllerApi
     */
    public processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization: string, salesOffice: string, options?: AxiosRequestConfig) {
        return UserGuidanceControllerApiFp(this.configuration).processAllInactiveUserGuidanceBySalesOfficeUsingGET(authorization, salesOffice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DownloadProcess
     * @param {string} authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGuidanceControllerApi
     */
    public processAllInactiveUserGuidanceUsingGET(authorization: string, options?: AxiosRequestConfig) {
        return UserGuidanceControllerApiFp(this.configuration).processAllInactiveUserGuidanceUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserLogControllerApi - axios parameter creator
 * @export
 */
export const UserLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET6: async (authorization: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('allUsingGET6', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('allUsingGET6', 'userId', userId)
            const localVarPath = `/api/v1/app/user-logs/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLogControllerApi - functional programming interface
 * @export
 */
export const UserLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allUsingGET6(authorization: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allUsingGET6(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserLogControllerApi - factory interface
 * @export
 */
export const UserLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List
         * @param {string} authorization token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allUsingGET6(authorization: string, userId: string, options?: any): AxiosPromise<Array<UserLog>> {
            return localVarFp.allUsingGET6(authorization, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLogControllerApi - object-oriented interface
 * @export
 * @class UserLogControllerApi
 * @extends {BaseAPI}
 */
export class UserLogControllerApi extends BaseAPI {
    /**
     * 
     * @summary List
     * @param {string} authorization token
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLogControllerApi
     */
    public allUsingGET6(authorization: string, userId: string, options?: AxiosRequestConfig) {
        return UserLogControllerApiFp(this.configuration).allUsingGET6(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserManualControllerApi - axios parameter creator
 * @export
 */
export const UserManualControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getUserManual
         * @param {string} authorization token
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserManualUsingGET: async (authorization: string, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUserManualUsingGET', 'authorization', authorization)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getUserManualUsingGET', 'fileName', fileName)
            const localVarPath = `/api/v1/app/user-manuals/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {'USER' | 'ADMIN'} [manualType] manualType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeUserManualUsingPOST: async (authorization: string, files: any, manualType?: 'USER' | 'ADMIN', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeUserManualUsingPOST', 'authorization', authorization)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('storeUserManualUsingPOST', 'files', files)
            const localVarPath = `/api/v1/app/user-manuals/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (manualType !== undefined) {
                localVarQueryParameter['manualType'] = manualType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserManualControllerApi - functional programming interface
 * @export
 */
export const UserManualControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserManualControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getUserManual
         * @param {string} authorization token
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserManualUsingGET(authorization: string, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserManualUsingGET(authorization, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {'USER' | 'ADMIN'} [manualType] manualType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeUserManualUsingPOST(authorization: string, files: any, manualType?: 'USER' | 'ADMIN', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetaDataVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeUserManualUsingPOST(authorization, files, manualType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserManualControllerApi - factory interface
 * @export
 */
export const UserManualControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserManualControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getUserManual
         * @param {string} authorization token
         * @param {string} fileName fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserManualUsingGET(authorization: string, fileName: string, options?: any): AxiosPromise<string> {
            return localVarFp.getUserManualUsingGET(authorization, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {any} files files
         * @param {'USER' | 'ADMIN'} [manualType] manualType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeUserManualUsingPOST(authorization: string, files: any, manualType?: 'USER' | 'ADMIN', options?: any): AxiosPromise<FileMetaDataVO> {
            return localVarFp.storeUserManualUsingPOST(authorization, files, manualType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserManualControllerApi - object-oriented interface
 * @export
 * @class UserManualControllerApi
 * @extends {BaseAPI}
 */
export class UserManualControllerApi extends BaseAPI {
    /**
     * 
     * @summary getUserManual
     * @param {string} authorization token
     * @param {string} fileName fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManualControllerApi
     */
    public getUserManualUsingGET(authorization: string, fileName: string, options?: AxiosRequestConfig) {
        return UserManualControllerApiFp(this.configuration).getUserManualUsingGET(authorization, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {any} files files
     * @param {'USER' | 'ADMIN'} [manualType] manualType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManualControllerApi
     */
    public storeUserManualUsingPOST(authorization: string, files: any, manualType?: 'USER' | 'ADMIN', options?: AxiosRequestConfig) {
        return UserManualControllerApiFp(this.configuration).storeUserManualUsingPOST(authorization, files, manualType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserStatusControllerApi - axios parameter creator
 * @export
 */
export const UserStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendGuidanceBulkUsingGET: async (authorization: string, userIds: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendGuidanceBulkUsingGET', 'authorization', authorization)
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('resendGuidanceBulkUsingGET', 'userIds', userIds)
            const localVarPath = `/api/v1/app/users-status/{userIds}/resendGuidanceBulk`
                .replace(`{${"userIds"}}`, encodeURIComponent(String(userIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendGuidanceByUserIdUsingGET: async (authorization: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendGuidanceByUserIdUsingGET', 'authorization', authorization)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendGuidanceByUserIdUsingGET', 'userId', userId)
            const localVarPath = `/api/v1/app/users-status/{userId}/resendGuidanceByUserId`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {string} ids 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusBulkUpdateUsingPUT: async (authorization: string, ids: string, param: UserStatusParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('statusBulkUpdateUsingPUT', 'authorization', authorization)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('statusBulkUpdateUsingPUT', 'ids', ids)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('statusBulkUpdateUsingPUT', 'param', param)
            const localVarPath = `/api/v1/app/users-status/{ids}/bulk-update`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT3: async (authorization: string, id: number, param: UserStatusParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUsingPUT3', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsingPUT3', 'id', id)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('updateUsingPUT3', 'param', param)
            const localVarPath = `/api/v1/app/users-status/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserStatusControllerApi - functional programming interface
 * @export
 */
export const UserStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendGuidanceBulkUsingGET(authorization: string, userIds: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendGuidanceBulkUsingGET(authorization, userIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendGuidanceByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendGuidanceByUserIdUsingGET(authorization, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {string} ids 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statusBulkUpdateUsingPUT(authorization: string, ids: string, param: UserStatusParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statusBulkUpdateUsingPUT(authorization, ids, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsingPUT3(authorization: string, id: number, param: UserStatusParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsingPUT3(authorization, id, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserStatusControllerApi - factory interface
 * @export
 */
export const UserStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendGuidanceBulkUsingGET(authorization: string, userIds: string, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.resendGuidanceBulkUsingGET(authorization, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ResendUserGuidance
         * @param {string} authorization 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendGuidanceByUserIdUsingGET(authorization: string, userId: string, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.resendGuidanceByUserIdUsingGET(authorization, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {string} ids 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusBulkUpdateUsingPUT(authorization: string, ids: string, param: UserStatusParam, options?: any): AxiosPromise<UserVO> {
            return localVarFp.statusBulkUpdateUsingPUT(authorization, ids, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update
         * @param {string} authorization 
         * @param {number} id 
         * @param {UserStatusParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT3(authorization: string, id: number, param: UserStatusParam, options?: any): AxiosPromise<UserVO> {
            return localVarFp.updateUsingPUT3(authorization, id, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserStatusControllerApi - object-oriented interface
 * @export
 * @class UserStatusControllerApi
 * @extends {BaseAPI}
 */
export class UserStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary ResendUserGuidance
     * @param {string} authorization 
     * @param {string} userIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStatusControllerApi
     */
    public resendGuidanceBulkUsingGET(authorization: string, userIds: string, options?: AxiosRequestConfig) {
        return UserStatusControllerApiFp(this.configuration).resendGuidanceBulkUsingGET(authorization, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ResendUserGuidance
     * @param {string} authorization 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStatusControllerApi
     */
    public resendGuidanceByUserIdUsingGET(authorization: string, userId: string, options?: AxiosRequestConfig) {
        return UserStatusControllerApiFp(this.configuration).resendGuidanceByUserIdUsingGET(authorization, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update
     * @param {string} authorization 
     * @param {string} ids 
     * @param {UserStatusParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStatusControllerApi
     */
    public statusBulkUpdateUsingPUT(authorization: string, ids: string, param: UserStatusParam, options?: AxiosRequestConfig) {
        return UserStatusControllerApiFp(this.configuration).statusBulkUpdateUsingPUT(authorization, ids, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update
     * @param {string} authorization 
     * @param {number} id 
     * @param {UserStatusParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStatusControllerApi
     */
    public updateUsingPUT3(authorization: string, id: number, param: UserStatusParam, options?: AxiosRequestConfig) {
        return UserStatusControllerApiFp(this.configuration).updateUsingPUT3(authorization, id, param, options).then((request) => request(this.axios, this.basePath));
    }
}


